import script from "./AuthCallback.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthCallback.vue?vue&type=script&setup=true&lang=js"

import "./AuthCallback.vue?vue&type=style&index=0&id=5c85f3cb&scoped=true&lang=css"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c85f3cb"]])

export default __exports__